import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { bolsas_bolsao_unidade, bolsas_bolsao_unidade_novos, bolsas_bolsao_unidade_renovados } from "../../services/api";

import './detalhamento_bolsa.css';

const Bolsa_bolsao_unidade = (props) => {

    const [data2, setData2] = useState([]);
    const [dataN, setDataN] = useState([]);
    const [dataR, setDataR] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await bolsas_bolsao_unidade(data_inicio, data_fim);
            setData2(response);
            const responseN = await bolsas_bolsao_unidade_novos(data_inicio, data_fim);
            setDataN(responseN);
            const responseR = await bolsas_bolsao_unidade_renovados(data_inicio, data_fim);
            setDataR(responseR);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {

        fetchData();
    }, [data_inicio, data_fim]);

    let chartBolbolUni = [];

    if (typeof data2 !== 'undefined') {

        const dadosFiltrados = data2.filter(item => item.sec === cod_unidade);
        chartBolbolUni = dadosFiltrados.map((item, index) => {

            if (item.sec === cod_unidade) {
                const row = ["Bolsão"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBolbolUni.length === 0) {
            chartBolbolUni.push(["Bolsão", 0]);
        }

        chartBolbolUni.unshift(["Label", "Value"]);
    };

    let chartBolbolUniN = [];

    if (typeof dataN !== 'undefined') {

        const dadosFiltradosN = dataN.filter(item => item.sec === cod_unidade);
        chartBolbolUniN = dadosFiltradosN.map((item, index) => {

            if (item.sec === cod_unidade) {
                const row = ["Bolsão N"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBolbolUniN.length === 0) {
            chartBolbolUniN.push(["Bolsão N", 0]);
        }

        chartBolbolUniN.unshift(["Label", "Value"]);
    };
    let chartBolbolUniR = [];

    if (typeof dataR !== 'undefined') {

        const dadosFiltradosR = dataR.filter(item => item.sec === cod_unidade);
        chartBolbolUniR = dadosFiltradosR.map((item, index) => {

            if (item.sec === cod_unidade) {
                const row = ["Bolsão R"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBolbolUniR.length === 0) {
            chartBolbolUniR.push(["Bolsão R", 0]);
        }

        chartBolbolUniR.unshift(["Label", "Value"]);
    };



    const options = {
        width: 120, height: 120,
        redFrom: 33, redTo: 66,
        yellowFrom: 24, yellowTo: 33,
        minorTicks: 5,
        max: 66,
        min: 0
    };


    return (
        <div className="bolsasMU">
            <center>

                Bolsa Média tipo Bolsão
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBolbolUni}
                    options={options}
                />
                Bolsa Média tipo Bolsão Alunos Novos
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBolbolUniN}
                    options={options}
                />
                Bolsa Média tipo Bolsão Alunos Renovados
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBolbolUniR}
                    options={options}
                />
            </center>
        </div>
    );
};
export default Bolsa_bolsao_unidade;
